/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContractOwnershipDto } from './subjectContractOwnershipDto.model';
import { VersionType } from './versionType.model';


export interface SubjectContractDto { 
    appendixNumber?: number;
    contractNumberOfficial?: string;
    counterpartyNumber?: string;
    durationMonths?: number;
    expirationDate?: string;
    fractionRentedAcreage?: number;
    id?: number;
    indefinite?: boolean;
    individualRent?: number;
    noticePeriodMonths?: number;
    owners?: Array<string>;
    ownerships?: Array<SubjectContractOwnershipDto>;
    pricePerHectare?: number;
    rent?: number;
    sentForSignature?: boolean;
    signatureDate?: string;
    state?: string;
    subcontract?: boolean;
    taxOwner?: number;
    tenants?: Array<string>;
    totalRentedAcreage?: number;
    validity?: string;
    validityExplanation?: string;
    versionType?: VersionType;
}
export namespace SubjectContractDto {
}


